import { styled } from "@mui/material/styles";

import { useNextTranslation } from "../../../hooks";
import { ProductItinerary, ProductItineraryProps } from "../ProductItinerary";
import { ProductSectionTitle } from "../ProductSectionTitle";
import { ProductSectionWrapper, ProductSectionWrapperProps } from "./ProductSectionWrapper";

type ProductItinerarySectionProps = Omit<ProductSectionWrapperProps, "children"> &
    Pick<ProductItineraryProps, "items"> & { title?: string };

export const ProductItinerarySection = ({ items, title, ...props }: ProductItinerarySectionProps) => {
    const [t] = useNextTranslation("product");

    const titleText = title ?? t("itinerary.title");
    return (
        <ProductItinerarySectionWrapper {...props} data-testid="product-itinerary-section">
            <ProductSectionTitle data-ref="product-itinerary-section-title">{titleText}</ProductSectionTitle>
            <ProductItinerary items={items} defaultExpanded={props.defaultExpanded} />
        </ProductItinerarySectionWrapper>
    );
};

const ProductItinerarySectionWrapper = styled(ProductSectionWrapper)(({ theme }) => ({
    [theme.breakpoints.up("md")]: {
        paddingInlineEnd: theme.spacing(20),
    },
}));
